import { Routes } from '@angular/router';
import {
  redirectUnauthorizedTo,
  canActivate,
  redirectLoggedInTo,
} from '@angular/fire/auth-guard';
import { TabsPage } from './tabs/tabs.page';
import { themeResolver } from './theme.resolver';
import { migrationGuard } from './migrations/migration.guard';

const redirectToLogin = () => redirectUnauthorizedTo(['login']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['/tabs/machines']);

const redirectToLoginGuard = canActivate(redirectToLogin);
const redirectLoggedInToHomeGuard = canActivate(redirectLoggedInToHome);

export const routes: Routes = [
  // Authenticated routes
  {
    path: '',
    redirectTo: '/tabs/machines',
    pathMatch: 'full',
  },
  {
    path: 'tabs',
    component: TabsPage,
    resolve: {
      theme: themeResolver,
    },
    runGuardsAndResolvers: 'always',
    canActivate: [...redirectToLoginGuard.canActivate, migrationGuard],
    data: {
      ...redirectToLoginGuard.data,
    },
    children: [
      {
        path: 'machines',
        loadChildren: () => import('./home/routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./reports/routes').then((m) => m.REPORTS_ROUTES),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./account/routes').then((m) => m.ACCOUNT_ROUTES),
      },
    ],
  },

  // Unauthenticated routes
  {
    path: 'login',
    loadChildren: () => import('./login/routes').then((m) => m.LOGIN_ROUTES),
    ...redirectLoggedInToHomeGuard,
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./forgot-password/routes').then((m) => m.FORGOT_PASSWORD_ROUTES),
    ...redirectLoggedInToHomeGuard,
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./register/routes').then((m) => m.REGISTER_ROUTES),
    ...redirectLoggedInToHomeGuard,
  },
];
